export const saveIsShow = (state, isShow) => {
  state.isShow = isShow;
};

// 设置shopify的对象
export const setShopifyAppObj = (state, val) => {
  state.shopifyAppObj = val;
}

//设置店铺域名
export const setShopDomain = (state, val) => {
  state.shopDomain = val;
}
//设置店铺货币符号
export const setCurrencySymbol = (state, val) => {
  state.currencySymbol = val
}

export const setWillDesk = (state, val) => {
  state.willDeskInfo = val;
};

//设置付费套餐类型
export const setPricingPlanId = (state, val) => {
  state.pricingPlanId = val
}

//是否开启我们app为默认拓展
export const setPostPurchaseActive = (state, val) => {
  state.PostPurchaseActive = val
}
//套餐类型
export const setPackagType = (state, val) => {
  state.packagType = val
}

//设置套餐权限
export const setRole = (state, val) => {
  state.role = val
}
export const setPostShow = (state, val) => {
  state.post.show = val
}
export const setUserName = (state, val) => {
  state.userName = val
}